// Firebase project config.
// These values are PUBLIC by design (they identify the project, not authorize it).
// Filled in once the real project exists. Override locally via .env if preferred.
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
import { getMessaging, isSupported as messagingSupported } from "firebase/messaging";

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FB_API_KEY || "REPLACE_API_KEY",
  authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN || "REPLACE.firebaseapp.com",
  projectId: import.meta.env.VITE_FB_PROJECT_ID || "REPLACE_PROJECT_ID",
  storageBucket: import.meta.env.VITE_FB_STORAGE_BUCKET || "REPLACE.appspot.com",
  messagingSenderId: import.meta.env.VITE_FB_SENDER_ID || "REPLACE_SENDER_ID",
  appId: import.meta.env.VITE_FB_APP_ID || "REPLACE_APP_ID",
  databaseURL: import.meta.env.VITE_FB_DATABASE_URL || "https://REPLACE-default-rtdb.firebaseio.com",
};

export const VAPID_KEY = import.meta.env.VITE_FB_VAPID_KEY || "REPLACE_VAPID_KEY";

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const rtdb = getDatabase(app);

// messaging is only usable in a secure context with SW support
export async function getMessagingIfSupported() {
  try {
    if (await messagingSupported()) return getMessaging(app);
  } catch (e) { /* ignore */ }
  return null;
}
